// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const DerivedFormulaGuide = reactLazyRetry(
  () => import('../../components/Configuration/DerivedFormulaGuide')
);
const WorkFlowList = reactLazyRetry(
  () => import('./workflow/pages/WorkFlowList')
);
const EditWorkflow = reactLazyRetry(
  () => import('./workflow/pages/EditWorkflow')
);
const GenerateWorkflow = reactLazyRetry(
  () => import('./workflow/pages/GenerateWorkflow')
);
const SystemID = reactLazyRetry(
  () => import('./entityManagement/pages/SystemID')
);
const IDViaTemplate = reactLazyRetry(
  () => import('./entityManagement/pages/IDViaTemplate')
);
const EntityManagement = reactLazyRetry(
  () => import('./entityManagement/pages/EntityManagement')
);
const EditEntityView = reactLazyRetry(
  () => import('./entityManagement/pages/EditEntityView')
);
const EditEntityTypeView = reactLazyRetry(
  () => import('./entityManagement/pages/EditEntityTypeView')
);
const EditTemplate = reactLazyRetry(
  () => import('./template/pages/EditTemplateView')
);
const TemplateList = reactLazyRetry(
  () => import('./template/pages/TemplateList')
);
const AttributeLibrary = reactLazyRetry(
  () => import('./attributeLibrary/pages/AttributeLibrary')
);
const ConstantAttributes = reactLazyRetry(
  () => import('./constantAttributes/pages/ConstantAttributes')
);
const GlobalAttributes = reactLazyRetry(
  () => import('./globalAttributes/pages/GlobalAttributes')
);
const TeamRolesView = reactLazyRetry(
  () => import('./teamRoles/pages/TeamRolesView')
);
const Rules = reactLazyRetry(() => import('./rules/pages/RulesList'));
const DocumentTemplate = reactLazyRetry(
  () => import('./documentTemplate/pages/DocumentTemplateList')
);
const WeaknessAssessment = reactLazyRetry(
  () => import('../../plugins/LLM/pages/WeaknessAssessmentList')
);
const DynamicChart = reactLazyRetry(
  () => import('./dynamicChart/pages/DynamicChart')
);
const ToolbarList = reactLazyRetry(
  () => import('./dynamicToolbar/pages/ToolbarList')
);
const CreateToolbarConfig = reactLazyRetry(
  () => import('./dynamicToolbar/pages/CreateToolbarConfig')
);
const EditToolbarConfig = reactLazyRetry(
  () => import('./dynamicToolbar/pages/EditToolbarConfig')
);
const AutomationList = reactLazyRetry(
  () => import('./automation/pages/AutomationList')
);
const CreateAutomation = reactLazyRetry(
  () => import('./automation/pages/CreateAutomation')
);
const AutomationLineage = reactLazyRetry(
  () => import('./automation/pages/AutomationLineage')
);
const AutomationExecutionLogs = reactLazyRetry(
  () => import('./automation/pages/AutomationExecutionLogs')
);
const AutomationExecutionLogDetails = reactLazyRetry(
  () => import('./automation/pages/AutomationExecutionLogDetails')
);
const ThemeAppearance = reactLazyRetry(
  () => import('./themeAppearance/pages/ThemeAppearance')
);
const DashboardConfig = reactLazyRetry(
  () => import('./dashboardConfig/pages/DashboardConfig')
);
const EmailTemplate = reactLazyRetry(
  () => import('./emailTemplate/pages/EmailTemplate')
);
const CreateEmailTemplateView = reactLazyRetry(
  () => import('./emailTemplate/pages/CreateEmailTemplateView')
);

/**
 * Configuration route definitions and metadata used by the application
 * router and permission-aware navigation (QuickLinks). Covers workflows,
 * entity/template/attribute management, rules, roles, automation,
 * toolbars, charts, theme/appearance and email templates.
 */
export const configurationRoutes = [
  {
    name: 'Workflows',
    key: 'workflow',
    path: DEFAULT_ROUTE_CONFIG?.workflow?.path || 'workflows',
    element: <WorkFlowList />,
    permission: 'Configuration_workflow',
    quickLink: {
      enabled: true,
      action: 'list',
    },
    children: [
      {
        name: 'Edit Workflow',
        key: 'editWorkflow',
        path:
          DEFAULT_ROUTE_CONFIG?.editWorkflow?.path ||
          'workflows/edit-workflow/:workflowType/:workflowId',
        element: <EditWorkflow />,
        permission: 'Configuration_workflow',
        quickLink: {
          enabled: true,
          dynamicTitle: true,
          action: 'update',
          resourceType: 'workflow',
          resourceIdParam: 'workflowId',
        },
      },
      {
        name: 'Generate Workflow',
        key: 'generateWorkflow',
        path:
          DEFAULT_ROUTE_CONFIG?.generateWorkflow?.path ||
          'workflows/generate-workflow',
        element: <GenerateWorkflow />,
        permission: 'Configuration_workflow',
        quickLink: {
          enabled: true,
          action: 'create',
        },
      },
    ],
  },
  {
    name: 'System ID',
    key: 'systemId',
    path: 'system-id',
    element: <SystemID />,
    permission: 'Configuration_dynamicId',
  },
  {
    name: 'ID via Template',
    key: 'idViaTemplate',
    path: 'id-via-template',
    element: <IDViaTemplate />,
    permission: 'Configuration_dynamicId',
  },
  {
    name: 'Entity Management',
    key: 'entityManagement',
    path: DEFAULT_ROUTE_CONFIG?.entityManagement?.path || 'entity-management',
    element: <EntityManagement />,
    permission: 'Configuration_entityManagement',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Templates',
    key: 'templateList',
    path: DEFAULT_ROUTE_CONFIG?.templateList?.path || 'templates',
    element: <TemplateList />,
    permission: 'Configuration_templateList',
    children: [
      {
        name: 'Create Template',
        key: 'createTemplate',
        path:
          DEFAULT_ROUTE_CONFIG?.createTemplate?.path ||
          'templates/create-template',
        element: <EditTemplate />,
        permission: 'Configuration_templateList',
        quickLink: {
          enabled: true,
          action: 'create',
        },
      },
      {
        name: 'Edit Template',
        key: 'editTemplate',
        path: DEFAULT_ROUTE_CONFIG.editTemplate.path,
        element: <EditTemplate />,
        permission: 'Configuration_templateList',
        quickLink: {
          enabled: true,
          dynamicTitle: true,
          action: 'update',
          resourceIdParam: 'tId',
          resourceType: 'template',
        },
      },
    ],
  },
  {
    name: 'Edit Entity',
    key: 'editEntity',
    path:
      DEFAULT_ROUTE_CONFIG?.editEntity?.path ||
      'configuration/entity/:uniqueId',
    element: <EditEntityView />,
    permission: 'Configuration_entityManagement',
    quickLink: {
      enabled: true,
      dynamicTitle: true,
      action: 'update',
    },
  },
  {
    name: 'Edit Entity Type',
    key: 'editEntityType',
    path:
      DEFAULT_ROUTE_CONFIG?.editEntityType?.path ||
      'entity-management/entity-type/:uniqueId',
    element: <EditEntityTypeView />,
    permission: 'Configuration_entityManagement',
    quickLink: {
      enabled: true,
      dynamicTitle: true,
      action: 'update',
      resourceType: 'entityType',
      resourceIdParam: 'uniqueId',
    },
  },
  {
    name: 'Global Attributes',
    key: 'globalAttributes',
    path: DEFAULT_ROUTE_CONFIG?.globalAttributes?.path || 'global-attributes',
    element: <GlobalAttributes />,
    permission: 'Configuration_globalAttributes',
  },
  {
    name: 'Attributes',
    key: 'Attributes',
    path: DEFAULT_ROUTE_CONFIG?.attributeLibrary?.path || 'attributes',
    element: <AttributeLibrary />,
    permission: 'Configuration_attributes',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Constant Attributes',
    key: 'ConstantAttributes',
    path:
      DEFAULT_ROUTE_CONFIG?.constantAttributes?.path || 'constant-attributes',
    element: <ConstantAttributes />,
    permission: 'Configuration_constantAttributes',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Derived Formula Guide',
    key: 'derivedFormulaGuide',
    path: 'derived-formula-guide',
    element: <DerivedFormulaGuide />,
  },
  {
    name: 'Rules',
    key: 'rules',
    path: DEFAULT_ROUTE_CONFIG?.rules?.path || 'rules',
    element: <Rules />,
    permission: 'Configuration_rules',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Team Roles',
    key: 'teamRoles',
    path: DEFAULT_ROUTE_CONFIG?.teamRoles?.path || 'team-roles',
    element: <TeamRolesView />,
    permission: 'Configuration_teamRoles',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Document Template',
    key: 'DocumentTemplate',
    path: DEFAULT_ROUTE_CONFIG?.documentTemplate?.path || 'document-template',
    element: <DocumentTemplate />,
    permission: 'Configuration_documentTemplate',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Weakness Assessment Template',
    key: 'WeaknessAssessment',
    path:
      DEFAULT_ROUTE_CONFIG?.weaknessAssessment?.path ||
      'weakness-assessment-template',
    element: <WeaknessAssessment />,
    // Reuses the Document Template configuration permission for now; give it a
    // dedicated permission once the backend exposes a Weakness Assessment key.
    permission: 'Configuration_documentTemplate',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Dynamic Chart',
    key: 'dynamicChart',
    path: DEFAULT_ROUTE_CONFIG?.dynamicChart?.path || 'dynamic-chart',
    element: <DynamicChart />,
    permission: 'Configuration_dynamicChart',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Dynamic Toolbar',
    key: 'dynamicToolbar',
    path: DEFAULT_ROUTE_CONFIG?.dynamicToolbar?.path || 'dynamic-toolbar',
    element: <ToolbarList />,
    permission: 'Configuration_dynamicToolbar',
    children: [
      {
        name: 'Create Dynamic Toolbar',
        key: 'createDynamicToolbar',
        path: DEFAULT_ROUTE_CONFIG?.createDynamicToolbar?.path,
        element: <CreateToolbarConfig />,
        permission: 'Configuration_dynamicToolbar',
      },
      {
        name: 'Edit Dynamic Toolbar',
        key: 'editDynamicToolbar',
        path: DEFAULT_ROUTE_CONFIG?.editDynamicToolbar?.path,
        element: <EditToolbarConfig />,
        permission: 'Configuration_dynamicToolbar',
      },
    ],
  },
  {
    name: 'Automation',
    key: 'automation',
    path: DEFAULT_ROUTE_CONFIG?.automation?.path || 'automation',
    element: <AutomationList />,
    permission: 'Configuration_automation',
    quickLink: {
      enabled: true,
      action: 'list',
    },
    children: [
      {
        name: 'Create Automation',
        key: 'createAutomation',
        path:
          DEFAULT_ROUTE_CONFIG?.createAutomation?.path ||
          'automation/create-automation',
        element: <CreateAutomation />,
        permission: 'Configuration_automation',
        quickLink: {
          enabled: true,
          action: 'create',
        },
      },
      {
        name: 'Update Automation',
        key: 'updateAutomation',
        path:
          DEFAULT_ROUTE_CONFIG?.updateAutomation?.path ||
          'automation/update-automation/:id',
        element: <CreateAutomation />,
        permission: 'Configuration_automation',
        quickLink: {
          enabled: true,
          action: 'update',
          dynamicTitle: true,
          resourceIdParam: 'id',
          resourceType: 'automation',
        },
      },
      {
        name: 'Automation Lineage',
        key: 'automationLineage',
        path:
          DEFAULT_ROUTE_CONFIG?.automationLineage?.path ||
          'automation/lineage/:id',
        element: <AutomationLineage />,
        permission: 'Configuration_automation',
        quickLink: {
          enabled: true,
          action: 'view',
          dynamicTitle: true,
          resourceIdParam: 'id',
          resourceType: 'automation',
        },
      },
      {
        name: 'Execution Logs',
        key: 'automationExecutionLogs',
        path:
          DEFAULT_ROUTE_CONFIG?.automationExecutionLogs?.path ||
          'automation/execution-logs',
        element: <AutomationExecutionLogs />,
        permission: 'Configuration_automation',
        quickLink: {
          enabled: true,
          action: 'view',
        },
      },
      {
        name: 'Execution Detail',
        key: 'automationExecutionLogDetails',
        path:
          DEFAULT_ROUTE_CONFIG?.automationExecutionLogDetails?.path ||
          'automation/execution-logs/:executionId',
        element: <AutomationExecutionLogDetails />,
        permission: 'Configuration_automation',
        quickLink: {
          enabled: true,
          action: 'view',
          dynamicTitle: true,
          resourceIdParam: 'executionId',
          resourceType: 'automationExecution',
        },
      },
    ],
  },
  {
    name: 'Theme and Appearance',
    key: 'themeAndAppearance',
    path: DEFAULT_ROUTE_CONFIG?.themeAndAppearance?.path || 'theme-appearance',
    element: <ThemeAppearance />,
    permission: 'Configuration_themeAndAppearance',
    quickLink: {
      enabled: true,
      action: 'view',
    },
  },
  {
    name: 'Homepage Setup',
    key: 'homepageSetup',
    path: DEFAULT_ROUTE_CONFIG?.homepageSetup?.path || 'homepage-setup',
    element: <DashboardConfig />,
    permission: 'Configuration_homepageSetup',
  },
  {
    name: 'Email Template',
    key: 'EmailTemplate',
    path: DEFAULT_ROUTE_CONFIG?.emailTemplate?.path || 'email-template',
    element: <EmailTemplate />,
    permission: 'Configuration_emailTemplate',
    quickLink: {
      enabled: true,
      action: 'list',
    },
    children: [
      {
        name: 'Create Email Template',
        key: 'createEmailTemplate',
        path:
          DEFAULT_ROUTE_CONFIG?.createEmailTemplate?.path ||
          'email-template/create-email-template',
        element: <CreateEmailTemplateView />,
        permission: 'Configuration_emailTemplate',
        quickLink: {
          enabled: true,
          action: 'create',
        },
      },
      {
        name: 'Edit Email Template',
        key: 'editEmailTemplate',
        path:
          DEFAULT_ROUTE_CONFIG?.editEmailTemplate?.path ||
          'email-template/:uniqueId',
        element: <CreateEmailTemplateView />,
        permission: 'Configuration_emailTemplate',
        quickLink: {
          enabled: true,
          dynamicTitle: true,
          action: 'view',
        },
      },
    ],
  },
];
